import Countdown from "react-countdown"
import { Flex, Text } from "@chakra-ui/react"

import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"
import { useUI } from "providers/UIProvider"

const ReservationDetailsStatus: React.FC = () => {
  const { T } = useUI()
  const { currentReservation: reservation } = useReservationsContext()


  const displayTimeTitle = (statusId: number | undefined) => {
    let title = ""

    // if ((statusId === 1 || statusId === 2) && currentTime <= endTime) {
    //   title = T("booking.details.modal.until.cancellation")
    // }

    if (statusId === 3) {
      title = T("booking.details.modal.until.finish")
    }

    return title
  }



  const startDateTime = (reservation && reservation?.washStartDateTime) && new Date(reservation?.washStartDateTime).getTime()


  const renderDateTime = ({ completed, formatted: { hours, minutes, seconds } }: any) => {
    if (completed) {
      return <></>
    }
    return <Text>{hours}:{minutes}:{seconds}</Text>
  }
  const renderTime = () => {
    const title = displayTimeTitle(reservation?.statusId)

    return (
      <>
        <Text fontSize={"xs"} color="warning" marginRight="20px">
          {title}
        </Text>
        <Text fontSize={"14px"} color="warning">
          {/* {reservation?.statusId === 1 && (
            <Countdown
              date={reservation.endDateTime}
              renderer={renderDateTime}
            />
          )} */}
          {((reservation?.washTimeInMinutes && reservation?.statusId === 3) &&
            <Countdown
              date={startDateTime + reservation.washTimeInMinutes * 60000}
              renderer={renderDateTime}
            />
          )}
        </Text>
      </>
    )
  }

  return (
    <Flex
      width="283px"
      height="120px"
      flexDirection={"column"}
      borderBottom={"1px solid #E9F2FD"}
      padding={"14px 0 20px  24px"}
    >
      <Text opacity={0.7} mb={"10px"} fontSize={"base"}>
        {T("booking.details.modal.booking.status")}
      </Text>
      <Text fontSize={"base"}>{reservation?.statusText}</Text>
      {renderTime()}
    </Flex>
  )
}

export default ReservationDetailsStatus